<template>
    <div v-show="activeIndex == index">
        <div class="search-top">
            <span>BU名称</span>
            <el-select class="top-choose" v-model="buId" @change="searchClick()">
                <z-limitOption v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.bu_name">
                </z-limitOption>
            </el-select>
            <span>时间</span>
            <el-date-picker class="top-choose" v-model="search.start_date" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker>
            <small>~</small>
            <el-date-picker class="top-choose" v-model="search.end_date" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker>
            <div class="back-btn blue" @click="searchClick()">查询</div>
            <!-- <div class="back-btn blue" @click="link">职级充值</div> -->
        </div>

        <div class="back-list search">
            <div class="list-head">
                <div>日期</div>
                <div>职级变化</div>
                <div>可分配职级</div>
                <div>详情</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item" v-for="item in dataList" :key="item.id">
                    <div>{{ item.billTime | justDate }}</div>
                    <div :class="{add:item.billType == 1,reduce:item.billType!=1}">{{ item.transAmount && (item.billType==1?"+":"-")+item.transAmount }}</div>
                    <div>{{ item.balance }}</div>
                    <div class="overhide">{{ item.remark }}</div>
                </div>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="searchClick"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>


    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        props:["activeIndex",'index'],
        data(){
            return {
                search:{
                    start_date:"",
                    end_date:"",
                },
                data:{},
                buId:"",
            }
        },
        computed:{
            ...mapState(["bu_list","picker_special"]),
            dataList(){
                return this.data.list;
            }
        },
        created(){
            if(this.activeIndex == this.index){
                this.$func.getBuList(true,list=>{
                    this.buId = list[0] && list[0].id;  //buId  变化会触发刷新
                });
            }
        },

        // watch:{
        //     activeIndex(val){
        //         if(val == this.index){
        //             this.fresh();
        //         }
        //     }
        // },

        methods:{
            fresh(){
                this.searchClick(this.data.current_page);
            },
            getData(obj={}){
                obj.bu_id = this.buId;
                let url = `api/admin/bu/pmtdetail`;
                this.$http.get(url,{params:obj}).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });
            },
            searchClick(page){  //查询
                let obj = {
                    page:page,
                    start_date:this.search.start_date,
                    end_date:this.search.end_date,
                }
                this.getData(obj);
            },
            // link(){
            //     let str = this.$crypto.encrypt(this.buId);
            //     this.$router.push({
            //         name:"back-person-bu-addrank",
            //         params:{
            //             buId:str,
            //         },
            //     });
            // },
        },
    }
</script>

<style lang="less" scoped>

    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 20%;
        }
        >div:nth-of-type(2){
            width: 23%;
        }
        >div:nth-of-type(3){
            width: 22%;
        }
        >div:last-of-type{
            width: 35%;
        }
        .add{
            color:#34b96c;
            // color:#43a2ff;
        }
        .reduce{
            color:#ff8383;
        }
    }
</style>





// WEBPACK FOOTER //
// rank-note.vue?d16452aa